/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMyCompaniesResponse } from '../../models/get-my-companies-response';

export interface GetMyUniqueCompanies$Params {
}

export function getMyUniqueCompanies(http: HttpClient, rootUrl: string, params?: GetMyUniqueCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMyCompaniesResponse>> {
  const rb = new RequestBuilder(rootUrl, getMyUniqueCompanies.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMyCompaniesResponse>;
    })
  );
}

getMyUniqueCompanies.PATH = '/api/v1/companies/mine';
